import React from "react";
import activityOverviewHeaderStyles from "./activityOverviewHeaderStyles";
import Grid from "@mui/material/Grid";
import ProductFilter from "../../../components/Activities/ActivityOverviewHeader/ProductFilter/ProductFilter";
import ActivityTypeFilter from "../../../components/Activities/ActivityOverviewHeader/ActivityTypeFilter/ActivityTypeFilter";
import OperationalEmployeeFilter from "../../../components/Activities/ActivityOverviewHeader/UserFilter/OperationalEmployeeFilter";
import { MenuItem, Select } from "@mui/material";
import _ from "lodash";
import { ACTIVITY_OVERDUE } from "../../../services/Activities/ActivityStatus";
import ValidatorSelect from "../../../components/Validator/ValidatorSelect";
import { BackofficeUser } from "../../../types/BackofficeUser";
import { Activity } from "../../../types/Activity";

type ActivityOverviewHeaderProps = {
  isDeadlineView?: boolean;
  productFilter: string;
  setProductFilter: (value: string) => void;
  activityTypeFilter: string;
  setActivityTypeFilter: Function;
  userFilter: string;
  setUserFilter: Function;
  timespanFilter: string;
  setTimespanFilter: Function;
  agents: BackofficeUser[];
  isLoading?: boolean;
  setOpenOrDoneFilter?: Function;
  openOrDoneFilter?: string;
  hasActivityTypeFilter?: boolean;
  overdueTotal: number;
  todayTotal: number;
};

const ActivityOverviewHeader = ({
  productFilter,
  isDeadlineView,
  setProductFilter,
  activityTypeFilter,
  setActivityTypeFilter,
  userFilter,
  setUserFilter,
  timespanFilter,
  setTimespanFilter,
  agents,
  isLoading,
  setOpenOrDoneFilter,
  openOrDoneFilter,
  hasActivityTypeFilter = true,
  overdueTotal,
  todayTotal
}: ActivityOverviewHeaderProps) => {
  const isCompletedView = openOrDoneFilter === "done";

  if (
    (isCompletedView && !["today", "yesterday"].includes(timespanFilter)) ||
    (!isCompletedView && timespanFilter === "yesterday")
  ) {
    setTimespanFilter("today");
  }
  return (
    <Grid
      container
      spacing={2}
      sx={[{
        alignItems: "center"
      }, activityOverviewHeaderStyles.filterContainer]}>
      <Grid size={6} />
      {!isDeadlineView && (
        <Grid size={12}>
          <ValidatorSelect
            label="Status"
            onChange={({ target }) => {
              _.isFunction(setOpenOrDoneFilter) && setOpenOrDoneFilter(target.value);
            }}
            value={openOrDoneFilter}
            fullWidth
          >
            <MenuItem value={"open"}>Offen</MenuItem>
            <MenuItem value={"done"}>Erledigt</MenuItem>
          </ValidatorSelect>
        </Grid>
      )}
      <Grid size={12}>
        <ProductFilter productFilter={productFilter} setProductFilter={setProductFilter} />
      </Grid>
      {hasActivityTypeFilter && (
        <Grid size={12}>
          <ActivityTypeFilter
            activityTypeFilter={activityTypeFilter}
            setActivityTypeFilter={setActivityTypeFilter}
            isDeadlineView={!!isDeadlineView}
          />
        </Grid>
      )}
      <Grid size={12}>
        <OperationalEmployeeFilter
          userFilter={userFilter}
          setUserFilter={setUserFilter}
          agents={agents}
          isDeadlineView={!!isDeadlineView}
        />
      </Grid>
      <Grid size={12}>
        <Select value={timespanFilter} onChange={(event) => setTimespanFilter(event.target.value)} fullWidth>
          {!isCompletedView && <MenuItem value={"overdue"}>Überfällig</MenuItem>}
          {isCompletedView && <MenuItem value={"yesterday"}>Gestern</MenuItem>}
          <MenuItem value={"today"}>Heute</MenuItem>
          {!isCompletedView && <MenuItem value={"tomorrow"}>Morgen</MenuItem>}
        </Select>
      </Grid>
      <Grid sx={activityOverviewHeaderStyles.activitiesToday} size={6}>
        {userFilter !== "all" && !isLoading && <span>Heute noch: {todayTotal}</span>}
      </Grid>
      <Grid sx={activityOverviewHeaderStyles.activitiesOverdue} size={6}>
        {userFilter !== "all" && !isLoading && <span>Davon überfällig: {overdueTotal}</span>}
      </Grid>
    </Grid>
  );
};

export default ActivityOverviewHeader;
